import React from "react";
import {
	Box,
	HStack,
	Flex,
	Text,
	SimpleGrid,
	Select,
	Stack,
	Switch,
	Button,
	Icon,
	Link,
	Slider,
	SliderTrack,
	SliderFilledTrack,
	SliderThumb,
} from "@chakra-ui/react";
import { ArrowBackIcon } from "@chakra-ui/icons";
import { CiUndo } from "react-icons/ci";
import { Link as ReachLink } from "react-router-dom";

function ConfigureAPI() {
	return (
		<Box pt={{ base: "120px", md: "75px" }}>
			<HStack justify="space-between" mb={4}>
				<Flex align="center" gap={3}>
					<Link as={ReachLink} to="/admin/apis">
						<ArrowBackIcon boxSize={6} />
					</Link>

					<Text fontSize="2xl" fontWeight="bold">
						Configure API
					</Text>
				</Flex>
				<Button bg="#48484F">View API Key</Button>
			</HStack>
			<SimpleGrid columns={{ sm: 1, md: 2, lg: 2 }} gap={10}>
				<Flex direction="column" gap={10}>
					<Box mt={3}>
						<Text fontSize="2xl" mb={2}>
							Index
						</Text>
						<Select
							placeholder="Select"
							size="lg"
							bg="#3D3D44"
							borderRadius="16px"
						>
							<option value="option1">Option 1</option>
							<option value="option2">Option 2</option>
							<option value="option3">Option 3</option>
						</Select>
					</Box>
					<Stack direction="row">
						<Switch size="lg" />
						<Text fontSize="2xl" mb={2}>
							Search
						</Text>
					</Stack>
					<Stack direction="row">
						<Switch size="lg" />
						<Text fontSize="2xl" mb={2}>
							Embed and Store/Update
						</Text>
					</Stack>
				</Flex>
				<Flex direction="column" gap={10}>
					<Flex direction="column" gap={3}>
						<HStack justify="space-between">
							<Text fontSize="2xl" mb={2}>
								Rate Limit
							</Text>
							<Stack direction="row" align="center">
								<Icon as={CiUndo} boxSize={7} />
								<Button>1</Button>
							</Stack>
						</HStack>
						<Slider aria-label="slider-ex-1" defaultValue={30}>
							<SliderTrack>
								<SliderFilledTrack />
							</SliderTrack>
							<SliderThumb />
						</Slider>
					</Flex>
					<Stack direction="row">
						<Switch size="lg" />
						<Text fontSize="2xl" mb={2}>
							Delete
						</Text>
					</Stack>
					<Stack direction="row">
						<Switch size="lg" />
						<Text fontSize="2xl" mb={2}>
							Chat
						</Text>
					</Stack>
					<Flex gap={3} justify="flex-end">
						<Button bg="#48484F" borderRadius="16px">
							Cancel
						</Button>
						<Button
							bg="#16BF5D
"
							borderRadius="16px"
						>
							Save
						</Button>
					</Flex>
				</Flex>
			</SimpleGrid>
		</Box>
	);
}

export default ConfigureAPI;
